import AxiosUtil from '../utils/axiosUtil';
import { BaseService } from './BaseService';

export const EnterpriseService = (function () {
  let instance;
  const BASE_URI = '/apis/enterprises';
  const baseService = BaseService.getInstance(BASE_URI, 'enterprise');

  function init() {
    return {
      ...baseService,
      checkAvailable: async function (code = '', data) {
        const { associationId = 1 } = data;
        return await AxiosUtil.Async.get(
          BASE_URI + `/check/available-code`,
          `aid=${associationId}&ec=${code}`
        );
      },
      register: async function (data) {
        return await AxiosUtil.Async.post(BASE_URI, data);
      },
      update: async function (data) {
        return await AxiosUtil.Async.put(BASE_URI, data);
      },
      list: async function (params) {
        const queryString = Object.entries(params)
          .map((e) => e.join('='))
          .join('&');
        return await AxiosUtil.Async.get(BASE_URI, queryString);
      },
      getData: async function (enterpriseId) {
        return await AxiosUtil.Async.get(BASE_URI + `/${enterpriseId}`);
      },
      delete: async function (enterpriseId) {
        return await AxiosUtil.Async.delete(BASE_URI + `/${enterpriseId}`);
      },
    };
  }

  return {
    getInstance: function () {
      if (!instance) instance = init();
      return instance;
    },
  };
})();
